/*
 *
 * GiftCardsList reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_GIFTCARDLIST_SUCCESS,
  FETCH_FILTER_SUCCESS,
  STORE_CLIENT_ID,
} from './constants';

const initialState = fromJS({
  categoryList: [],
  discountList: [],
  brandList: [],
  giftCardList: {},
  giftcards_clientid: 'payment_gateway',
  couponCodeList: [],
});

function giftCardsListReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    case FETCH_GIFTCARDLIST_SUCCESS:
      return state
        .set('giftCardList', fromJS(action.payload));
    case STORE_CLIENT_ID:
      return state
        .set('giftcards_clientid', fromJS(action.payload)); /** @todo this need to be resetted onces user comes of the redeem flow */
    case FETCH_FILTER_SUCCESS: {
      const {
        categories,
        discounts,
        vendors,
        propel_coupon_codes = [],
      } = action.payload;
      return state
        .set('categoryList', fromJS(categories))
        .set('discountList', fromJS(discounts))
        .set('brandList', fromJS(vendors))
        .set('couponCodeList', fromJS(propel_coupon_codes));
    }
    default:
      return state;
  }
}

export default giftCardsListReducer;



// WEBPACK FOOTER //
// client/containers/GiftCardsList/reducer.js